import { Button, Grid, Switch, Theme, makeStyles } from "@material-ui/core";
import FormatListBulletedSharpIcon from "@material-ui/icons/FormatListBulletedSharp";
import { ColDef, ICellRendererParams } from "ag-grid-community";
import moment from "moment";
import React from "react";
import { useJobsContext } from "../../../context/JobsContext";
import { Job } from "../../../models/Job";

const useStyles = makeStyles((theme: Theme) => ({
	buttons: {},
}));

type Props = {
	setShowModal: (modal: "create" | "update" | "reset" | "enable" | "") => void;
	setJobSelected: (job: Job) => void;
	showContextMenu: Function;
};

export const useJobsTableData = ({
	setShowModal,
	setJobSelected,
	showContextMenu,
}: Props) => {
	const {
		state: { jobsData: rows },
	} = useJobsContext();
	const classes = useStyles();

	const renderButtonMenu = (params: any) => {
		return (
			<Grid
				container
				style={{
					height: "100%",
					display: "flex",
					justifyContent: "center",
					alignItems: "center",
				}}
				className={classes.buttons}
			>
				<Grid
					item
					xs={12}
					md={12}
					style={{
						display: "flex",
						justifyContent: "center",
						alignItems: "center",
					}}
				>
					<Button
						style={{}}
						onClick={(e) => showContextMenu(e, params.data, "jobsContext")}
					>
						<FormatListBulletedSharpIcon color="action" fontSize="small" />
					</Button>
				</Grid>
			</Grid>
		);
	};

	const columnDefs: ColDef[] = [
		{
			field: "sProcedure",
			minWidth: 240,
			headerName: "Procedures",
			type: "string",
			flex: 2,
			cellStyle: {
				display: "flex",
				alignItems: "center",
				justifyContent: "center",
			},
		},
		{
			field: "PeriodTime",
			minWidth: 90,
			maxWidth: 90,
			headerName: "Period Time",
			flex: 1,
			valueFormatter: ({ value }) => {
				if (value === null || value === undefined) return "";

				const horas = Math.floor(value / 3600);
				const minutos = Math.floor((value % 3600) / 60);
				const segundos = value % 60;

				return `${horas}h ${minutos}min ${segundos}s`;
			},
			cellStyle: {
				display: "flex",
				alignItems: "center",
				justifyContent: "center",
			},
		},
		{
			field: "NextExecutionTime",
			minWidth: 115,
			maxWidth: 125,
			headerName: "Next Execution",
			valueFormatter: ({ value }) =>
				value === null ? "" : moment(value).format("DD/MM/YYYY HH:mm"),
			flex: 1,
			cellStyle: {
				display: "flex",
				alignItems: "center",
				justifyContent: "center",
			},
		},
		{
			field: "Enabled",
			headerName: "Enabled",
			minWidth: 50,
			maxWidth: 100,
			valueFormatter: ({ value }) => (!value ? "N" : "Y"),
			flex: 1,
			cellStyle: {
				display: "flex",
				alignItems: "center",
				justifyContent: "center",
			},
			cellRenderer: (params: ICellRendererParams) => (
				<Switch
					checked={!!(params.data as Job).Enabled}
					color="primary"
					size="small"
					onChange={(event, checked) => {
						setJobSelected(params.data);
						setShowModal("enable");
					}}
				/>
			),
		},
		{
			field: "-",
			headerName: "",
			cellRenderer: renderButtonMenu,
			flex: 1,
			wrapText: false,
			autoHeight: false,
			wrapHeaderText: false,
			sortable: false,
			cellStyle: {
				display: "flex",
				alignItems: "center",
				justifyContent: "center",
			},
		},
	];

	return { rows, columnDefs };
};
